import React from 'react'
import ResultTable from './Result'
const approvedCRM = () => {
  return (
   <ResultTable/>
  )
}

export default approvedCRM